<template>
    <div>
        <h4 class="atlhr-dashboard-title mt-10 px-0 mb-0">PF Settings<span>
            <a v-bind:href="$api_url + '/company/dashboard'">Dashboard</a> / Settings / PF Migration Date Lock</span>
        </h4>
        <div class="ibox">
            <div class="  clearfix row no-margin ibox-content mt-3">
                <div class="col-md-12 fixed-section-one mb-4">
                    <div class="clearfix approval-container row">
                        <div class="col-4 approve-level-label">
                            <div class="approve-level-title px-0 text-left">
                                PF Migration Date Lock
                            </div>
                            <div class="approve-level-description">
                                The PF Migration Date denotes the date on which the PF Module is made online such that all migrated PF balances of employees are as at the end of the day on the Migration Date. When Onboarding Migrated Former Members, this date will be used by default if set and locked.
                            </div>
                        </div>
                        <div class="col-8 approve-level-content">
                            <div class="clearfix px-0 border-bottom">
                                <div class="clearfix">
                                    <div class="clearfix px-0 border-bottom">
                                        <div class="clearfix">
                                            <div class="row mx-1 mt-3 py-2 w-100 align-items-center no-margin">
                                                <!-- Migration Date Field -->
                                                <div class="col-6">
                                                    <b-form-group label="Migration Date [YYYY-MM-DD]" label-for="migration_date">
                                                        <b-input-group class="mb-3">
                                                            <b-form-input id="migration_date" name="migration_date" placeholder="YYYY-MM-DD"
                                                                v-model="fdata.migration_date" :disabled="!isMigrationLockEnabled"
                                                                v-validate="{ required: isMigrationLockEnabled, date_format: 'yyyy-MM-dd' }"
                                                                :class="{ 'is-invalid': veeErrors.has('migration_date') }" @change="saveSettings" :state="validateState('migration_date')" aria-describedby="migration_date-feedback"
                                                                data-vv-as="Migration Date" /> <!-- Mustafijur: 24-06-2026: Added :state="validateState('migration_date')" aria-describedby="migration_date-feedback" data-vv-as="Migration Date"-->
                                                            <b-input-group-append>
                                                                <b-form-datepicker v-model="fdata.migration_date" button-only right
                                                                    :disabled="!isMigrationLockEnabled" @input="saveSettings" />
                                                            </b-input-group-append>
                                                            <b-form-invalid-feedback v-if="veeErrors.has('migration_date')" class="pl-2">
                                                                {{ veeErrors.first('migration_date') }}
                                                            </b-form-invalid-feedback>
                                                        </b-input-group>
                                                    </b-form-group>
                                                </div>

                                                <!-- Migration Lock Checkbox -->
                                                <!-- <div class="col-6 d-flex align-items-center"> --> <!-- Rejwan: 09-09-2025 ACL -->
                                                <div class="col-6 d-flex align-items-center" v-if="$acl['company/savepfsettings'] == 2"> <!-- Rejwan: 09-09-2025 ACL -->
                                                    <b-form-checkbox v-model="checkboxValue" :value="1" :unchecked-value="0" @change="saveSettings"
                                                        switch class="mt-2">
                                                    </b-form-checkbox>
                                                    Enable Migration Date Lock
                                                    <!-- <b-icon icon="info-circle" title="Enable Migration Date Lock" v-b-tooltip class="ml-1"></b-icon> -->
                                                    <b-icon icon="info-circle" :title="title" v-b-tooltip class="ml-1"></b-icon>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment';

export default {
    data() {
        return {
            fdata: {
                enable_migration_date_lock: 0,
                migration_date: null
            },
            title: "The PF Migration Date denotes the date on which the PF Module is made online such that all migrated PF balances of employees are as at the end of the day on the Migration Date. When Onboarding Migrated Former Members, this date will be used by default if set and locked.",
        };
    },
    computed: {
        // Bound to checkbox
        checkboxValue: {
            get() {
                return this.fdata.enable_migration_date_lock;
            },
            set(val) {
                this.fdata.enable_migration_date_lock = val;
            }
        },
        isMigrationLockEnabled() {
            return this.fdata.enable_migration_date_lock == 1;
        }
    },
    methods: {
        getSettings() {
            axios
                .get(this.$api_url + '/pf/get-migration-date-settings')
                .then(response => {
                    let res = response.data || {};
                    if (res.enable_migration_date_lock == 1) {
                        this.fdata.enable_migration_date_lock = 1;
                    } else {
                        this.fdata.enable_migration_date_lock = 0;
                    }
                    this.fdata.migration_date = res.migration_date || null;
                })
                .catch(err => {
                    console.error(err);
                });
        },
        saveSettings() {
            if (this.fdata.enable_migration_date_lock == 1 && !this.fdata.migration_date) {
                this.fdata.migration_date = moment().format('YYYY-MM-DD');
            }

            axios
                .post(this.$api_url + '/pf/set-migration-date-settings', this.fdata)
                .then(response => {
                    if (response.data.status == '200') {
                        this.$bvToast.toast(response.data.message, {
                            title: 'Success',
                            variant: 'success',
                            solid: true
                        });
                    } else {
                        this.$bvToast.toast(response.data.message, {
                            title: 'Error',
                            variant: 'danger',
                            solid: true
                        });
                    }
                    this.getSettings();
                })
                .catch(error => {
                    this.serverError(error);
                });
        }
    },
    mounted() {
        this.getSettings();
    }
};
</script>